import { useContext } from 'react';
import CheckBoxInput from '../../../../Components/CheckBoxInput';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import PageHeading from '../../../../Components/PageHeading';
//mui imports====
import useCommonStyles from '../../../../commonStyles';
import Typography from '@mui/material/Typography';
import { Grid, Paper } from '@mui/material';
//===============

const FloatingUnitConfig = ({ keyData, featureDescription }) => {
	const { rawConfig, updateRawConfig } = useContext(ConfigContext); //rawConfig from ConfigContext
	const commonStyleClasses = useCommonStyles();
	return (
		<Paper
			style={{ paddingBottom: '6rem' }}
			className={commonStyleClasses.mainPagePaperMarginStyle}
		>
			<PageHeading
				headingName="Floating Unit Config"
				headingPath={['Dashboard', 'Framerate', 'Features Data', 'Floating Unit Config']}
				description="Controlled Floating will disable default behaviour of floating player to provide controlled configuration for above/below fold float."
				showInfoButton = {true}
				infoMessage={featureDescription}
			/>
			<Grid container spacing={1} style={{ width: '96.5%', marginLeft: '4rem' }}>
				<Grid item xs={12} style={{ marginTop: '3rem' }}>
					<CheckBoxInput
						keyData={keyData + '.enabled'}
						label="Controlled Floating"
						disabled={false}
						defaultChecked={false}
						object={rawConfig}
						updateObject={updateRawConfig}
						containerStyles={{ width: 'fit-content', margin: 0 }}
					/>
				</Grid>
				<Grid item xs={4}>
					<DeviceConfig keyData={keyData} label="Desktop" deviceType="DESKTOP" />
				</Grid>
				<Grid item xs={4}>
					<DeviceConfig keyData={keyData} label="Mobile" deviceType="MOBILE" />
				</Grid>
				<Grid item xs={4}>
					<DeviceConfig keyData={keyData} label="Tablet" deviceType="TABLET" />
				</Grid>
			</Grid>
		</Paper>
	);
};

const DeviceConfig = ({ label, deviceType, keyData }) => {
	//label="Desktop" deviceType="DESKTOP" keyData="featuresData.floatingUnitConfig"
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);
	const commonStyleClasses = useCommonStyles();

	return (
		<Grid
			container
			spacing={1}
			className={commonStyleClasses.basicOutlinedBox}
			style={{ width: '100%', margin: '0 auto' }}
		>
			<Grid item xs={12}>
				<Typography fontWeight={600} variant="h3">
					{label}
				</Typography>
			</Grid>
			<Grid item xs={12} style={{ marginTop: '1rem' }}>
				<CheckBoxInput
					keyData={`${keyData}.${deviceType}.aboveFold`}
					label="Above Fold"
					disabled={!rawConfig[keyData + '.enabled']}
					defaultChecked={false}
					object={rawConfig}
					updateObject={updateRawConfig}
					containerStyles={{ width: 'fit-content', margin: 0 }}
				/>
			</Grid>
			<Grid item xs={12} style={{ marginTop: '0rem' }}>
				<CheckBoxInput
					keyData={`${keyData}.${deviceType}.belowFold`}
					label="Below Fold"
					disabled={!rawConfig[keyData + '.enabled']}
					defaultChecked={false}
					object={rawConfig}
					updateObject={updateRawConfig}
					containerStyles={{ width: 'fit-content', margin: 0 }}
				/>
			</Grid>
		</Grid>
	);
};
export default FloatingUnitConfig;
